<template>
    <div class="chat" v-if="chat">
        <header class="header">
            <div class="container">
                <a @click.prevent="checkForHelp" class="btn btn--icon btn--white"><i class="material-icons">keyboard_arrow_left</i></a>

                <div class="profile profile--horizontal profile--horizontal-xs">
                    <figure class="profile__avatar mr--sm">
                        <span class="profile__avatar__img">
                            <img :src="chatWith.user.avatar" alt="">
                            <span v-if="chatWith.user.is_online" class="status status--success"></span>
                        </span>
                    </figure>

                    <div class="profile__text">
                        <div class="profile__name">{{ chatWith.user.nick }}</div>
                    </div>
                </div>
            </div>
        </header>

        <div class="chat__content">
            <template v-for="(message, index) in chat.lastMessages">
                <div class="chat__date" v-if="showGroupDate(index)" >{{ message.group_date }}</div>

                <div class="chat__message" :class="{'chat__message--left': user.id !== message.user.id, 'chat__message--right': user.id == message.user.id}">
                    <figure class="profile__avatar" v-if="user.id !== message.user.id">
                    <span class="profile__avatar__img">
                        <img :src="message.user.avatar" alt="">
                    </span>
                    </figure>

                    <div class="chat__bubble">
                        <div class="chat__bubble__content">
                            <p>{{ message.message }}</p>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <div class="chat__footer">
            <div class="container">
                <input type="text" @keyup.enter="sendMessage" :readonly="! subscribed" class="form-control form-control--gray" v-model="draftMessage" placeholder="Type message" />
                <button @click="sendMessage" :disabled="! subscribed" class="btn btn--sm btn--secondary">Send</button>
            </div>
            <div class="container" v-if="! subscribed">You have connection problems, please try again later!</div>
        </div>

        <modal show="false" type="success" ref="askForHelpModal">
            <template v-slot:message>
                Did you get a useful answer?
            </template>

            <template v-slot:buttons>

                <div v-show="messagesCountInCurrentSession === 0">
                    <a href="#" @click.prevent="skipAskForHelp" class="btn btn--block btn--secondary">Skip, still waiting for it</a>
                    <hr />
                </div>
                <a href="#" @click.prevent="saveAskForHelp(true)" class="btn btn--block btn--green">Yes</a>
                <a href="#" @click.prevent="saveAskForHelp(false)" class="btn btn--block btn--primary">No</a>
            </template>
        </modal>
    </div>
</template>

<script>
import api from "../../api/chat";
import {mapState} from "vuex";
import internalBackRoute from "../../mixins/internalBackRoute";

export default {
    name: "Conversation",
    mixins: [internalBackRoute],

    props: {
        chatId: {
            type: String,
            required: true
        }
    },

    data: function () {
        return {
            chat: null,
            subscribed: false,
            messagesCountInCurrentSession: 0,
            draftMessage: '',
        }
    },

    computed: {
        ...mapState('auth', [
            'user'
        ]),

        chatWith() {
            return collect(this.chat.users)
                .filter((item) => item.user.id !== this.user.id)
                .first()
        }
    },

    updated: function () {
        this.$nextTick(function () {
            this.scrollDown()
        })
    },

    methods: {
        async loadChat() {
            try {
                let response = await api.loadChat(this.chatId)
                this.chat = response.data.data

                this.subscribe('chat-' + this.chat.id)
            } catch (error) {
                console.log(error)
            }
        },

        showGroupDate(index) {
            if (! index) {
                return this.chat.lastMessages[index].group_date
            }

            if (! this.chat) {
                return false
            }

            return this.chat.lastMessages[index-1].group_date !== this.chat.lastMessages[index].group_date
        },

        sendMessage() {
            if (! this.draftMessage.length) {
                return
            }

            this.send({
                event: "message",
                data: {
                    channel: 'chat-' + this.chat.id,
                    message: this.draftMessage,
                }
            })

            this.chat.lastMessages.push({
                created_at: moment().format('YYYY-MM-DD h:mm:ss'),
                group_date: moment().format('YYYY. MM. DD.'),
                message: this.draftMessage,
                user: {
                    id: this.user.id,
                    nick: this.user.nick,
                },
            })

            this.draftMessage = ''
        },

        skipAskForHelp() {
            this.$refs.askForHelpModal.close()
            this.handleBack('/')
        },

        checkForHelp() {
            if (this.chat.askForHelp && this.chat.askForHelp.user_id === this.user.id) {
                this.$refs.askForHelpModal.open()
                return
            }

            this.handleBack('/')
        },

        saveAskForHelp(choice) {
            this.$refs.askForHelpModal.close()

            axios.post('/web-api/ask-for-help/close', {
                choice: choice,
                chat_id: this.chatId
            });

            this.handleBack('/')
        },

        scrollDown() {
            $('.chat__content').scrollTop($('.chat__content').prop('scrollHeight'))
        }
    },

    created() {
        this.loadChat()

        Quiz.$on('pusher_internal:subscription_succeeded', (message) => {
            if (message.channel === 'chat-' + this.chat.id) {
                this.subscribed = true
                this.$store.dispatch('auth/refreshUnreadChats')
            }
        })

        Quiz.$on('ws-connection-close', () => {
            this.subscribed = false
        })

        Quiz.$on('chat_message', (message) => {
            this.messagesCountInCurrentSession++
            this.chat.lastMessages.push(message.data)
        })
    },

    mounted() {
        $('body').addClass('body--secondary')
    },

    beforeDestroy() {
        $('body').removeClass('body--secondary')
        this.unsubscribe('chat-' + this.chat.id)
        Quiz.$off('chat_message')
    }
}
</script>
